import { render, staticRenderFns } from "./CrearCodigos.vue?vue&type=template&id=6ecafaee"
import script from "./CrearCodigos.vue?vue&type=script&lang=js"
export * from "./CrearCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports